var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-none d-md-block small text-muted text-start"},[_c('p',{staticClass:"mt-2"},[_vm._v(" "+_vm._s(_vm.$t('pages.origination.offerPreview.hardpull'))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }